import { createAuthJsonHeaders } from './authBridge';
const FEEDBACK_URL = `${
  process.env.REACT_APP_API_V2_URL ?? ''
}/agent-core/feedback`;

interface FeedbackParams {
  conversationId: string;
  requestId: string;
  rating: 0 | 1;
  comment?: string;
}

export async function submitFeedback(params: FeedbackParams): Promise<void> {
  const headers = await createAuthJsonHeaders();
  const response = await fetch(FEEDBACK_URL, {
    method: 'POST',
    headers,
    credentials: 'include',
    body: JSON.stringify({
      conversationId: params.conversationId,
      requestId: params.requestId,
      rating: params.rating,
      ...(params.comment ? { comment: params.comment } : {})
    })
  });

  if (!response.ok) {
    throw new Error(`Feedback submission failed: ${response.status}`);
  }
}
